import { Block } from '@/components/base/Block'
import { PrimaryButton } from '@/components/base/Button'
import { buttonSize } from '@/components/base/Button/Base'
import { Heading3 } from '@/components/base/Heading'
import { Text5 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import useIsMobile from '@/hooks/useMobile'
import { align } from '@/styles/display'
import spaceStyle from '@/styles/space'
import { whiteSpace } from '@/styles/white_space'

interface Props {
  checked: boolean
  onShowModal: (isCancelModal: boolean) => void
}

export const OfferAcceptanceButtonSection = ({
  checked,
  onShowModal
}: Props): JSX.Element => {
  const app = useApp()
  const isMobile = useIsMobile()

  return (
    <Block
      margin={{ horizontal: spaceStyle.NONE, top: spaceStyle.M }}
      padding={{ vertical: spaceStyle.M }}
      backgroundColor={app.theme.whiteColor}
      style={{
        boxSizing: 'border-box',
        position: 'sticky',
        bottom: 0
      }}
    >
      <PrimaryButton
        margin={{ horizontal: spaceStyle.AUTO, bottom: spaceStyle.L }}
        onClick={
          checked
            ? () => {
                onShowModal(false)
              }
            : () => {}
        }
        maxWidth={'140px'}
        height={buttonSize.M}
        bgColor={checked ? app.theme.primaryMainColor : app.theme.inactiveColor}
      >
        <Heading3 fixedSPfontSize textColor={app.theme.whiteTextColor}>
          {'内定を承諾する'}
        </Heading3>
      </PrimaryButton>
      <Text5
        textColor={app.theme.mainTextColor}
        margin={{ horizontal: isMobile ? spaceStyle.NONE : spaceStyle.XXXXXL }}
        textAlign={isMobile ? align.LEFT : align.CENTER}
        whiteSpace={whiteSpace.PRE_LINE}
      >
        {`期限までにご回答が難しい場合、また内定を辞退される場合は、担当キャリアアドバイザーまでご連絡ください。
          内定のご承諾後、求人企業は他の採用選考を停止し、受け入れ準備を開始されますので、ご承諾後に辞退されることのないよう慎重にご判断をお願いします。`}
      </Text5>
    </Block>
  )
}
